import { InputErrorProps } from "./models/InputError.model";

const InputError = ({ errMsg }: InputErrorProps) => {
  return (
    <span className="text-xs text-red-500 first-letter:uppercase">
      {errMsg}
    </span>
  );
};

export default InputError;
